export default __webpack_public_path__ + "static/media/box.0cd33545.png";